import { useCallback, useRef } from 'react';

import type { PickingInfo } from '@deck.gl/core';
import type { MapRef } from 'react-map-gl/mapbox';

export const useDeckCursorHover = (mapRef: MapRef | null | undefined) => {
  const isHoveringRef = useRef(false);

  return useCallback(
    (info: PickingInfo) => {
      const map = mapRef?.getMap();
      const canvas = map?.getCanvas();

      if (!canvas) {
        return;
      }

      const isCurrentlyHovering = Boolean(info.object);

      if (isCurrentlyHovering && !isHoveringRef.current) {
        canvas.style.cursor = 'pointer';
        isHoveringRef.current = true;
      } else if (!isCurrentlyHovering && isHoveringRef.current) {
        canvas.style.cursor = '';
        isHoveringRef.current = false;
      }
    },
    [mapRef]
  );
};
